import './ACAD.scss';
import {PageManager} from '@mvps-genesis/bootstrap';
import {InputValueCopyTo} from 'extensions/input-value-copy-to';

export default class ACAD extends PageManager {

	constructor (pageContext) {
		super(pageContext);
	}

	onReady () {
		new InputValueCopyTo();

		this.initAddressValidation();
	}

	async initAddressValidation () {
		const addressValidationElement = document.getElementById('address-validation');

		if (!addressValidationElement) {
			return;
		}

		const {AddressValidation} = await import('extensions/address-validation');

		new AddressValidation(addressValidationElement);
	}

}
